export const isDataURL = (string: string) => {
  const isDataURL = /^\s*data:([a-z]+\/[a-z]+(;[a-z-]+=[a-z-]+)?)?(;base64)?,[a-z0-9!$&',()*+,;=\-._~:@/?%\s]*\s*$/i
  return !!string.match(isDataURL)
}
